import { wsClient, WsRecvType, IWsHandler } from '../client'

export interface ILiveLogNotification {
    clientId: string
    line: string
}

type ILiveLogNotificationHandler = IWsHandler<ILiveLogNotification>

const listeners: Array<(data: ILiveLogNotification) => void> = []

export function onLiveLogNotification(callback: (data: ILiveLogNotification) => void) {
    listeners.push(callback)
    return () => {
        const index = listeners.indexOf(callback)
        if (index > -1) {
            listeners.splice(index, 1)
        }
    }
}

export default function () {
    wsClient.submitHandler(WsRecvType.LiveLogNotification, ((packet) => {
        const data = packet.data as ILiveLogNotification | undefined
        if (!data || typeof data.clientId !== 'string' || typeof data.line !== 'string') return
        listeners.forEach(listener => listener(data))
    }) as ILiveLogNotificationHandler)
}
